<div class="d-flex profile-media">
  <img class="b-r-50" src="assets/images/dashboard/profile.png" alt="" />
  <div class="flex-grow-1">
    <span>{{getName()}}</span>
    <p class="mb-0 font-roboto">
      {{getRole()}} <i class="middle fa fa-angle-down"></i>
    </p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <li>
    <a routerLink="users/users-profile"
      ><i data-feather="user"></i><span>Настройки </span></a
    >
  </li>
  <li>
    <a (click)="logoutFunc()"
      ><i data-feather="log-in"> </i><span>Излез</span></a
    >
  </li>
</ul>
